import defaultRequestConfig from 'Platforms/woocommerce/requestConfig';

const platformRoute = defaultRequestConfig?.platformRoute;

export function addPlatformRoute<T extends string | undefined>(uri: T): T {
  if (!uri || !platformRoute || uri.startsWith('#') || uri.startsWith('?')) {
    return uri;
  }

  try {
    const url = new URL(uri, document.baseURI);
    if (
      (url.protocol !== 'http:' && url.protocol !== 'https:') ||
      url.origin !== window.location.origin ||
      url.pathname === platformRoute ||
      url.pathname.startsWith(`${platformRoute}/`)
    ) {
      return uri;
    }

    url.pathname = `${platformRoute}${url.pathname}`;
    return (
      uri.startsWith('/') && !uri.startsWith('//') ? `${url.pathname}${url.search}${url.hash}` : url.href
    ) as T;
  } catch {
    return uri;
  }
}
